<template>
    <Dialog :visible.sync="display" modal @update:visible="closeDialog">
        <template #header class="align-items-center dialog-size">
            <div style="font-size: 1.75rem">{{ implement.identification }}</div>
        </template>
        <div class="d-flex flex-column dialog-size">
            <div class="row mb-3 mx-0 mx-lg-3">
                <div class="col-12 col-lg-3 d-flex flex-lg-column flex-row align-items-center">
                    <b>{{ $t('AppImplementViewDialog.Fabricante') }}:</b>
                    <div class="pl-2 pl-lg-0">
                        {{ implement.manufacturer_name }}
                    </div>
                </div>
                <div class="col-12 col-lg-3 d-flex flex-lg-column flex-row align-items-center">
                    <b>{{ $t('AppImplementViewDialog.Modelo') }}:</b>
                    <div class="pl-2 pl-lg-0">
                        {{ implement.model_name }}
                    </div>
                </div>
                <div class="col-12 col-lg-3 d-flex flex-lg-column flex-row align-items-center">
                    <b>{{ $t('AppImplementViewDialog.Tipo') }}:</b>
                    <div class="pl-2 pl-lg-0 break-text">
                        {{ parseImplementType(implement.implement_type).text }}
                    </div>
                </div>
                <div class="col-12 col-lg-3 d-flex flex-lg-column flex-row align-items-center">
                    <b>{{ $t('AppImplementViewDialog.Última modificação') }}:</b>
                    <div class="pl-2 pl-lg-0">
                        {{ dateHourFormat(implement.last_modified_date) }}
                    </div>
                </div>
            </div>
            <hr class="dashed row mx-1 mx-lg-5"/>
            <div>
                <app-implement-measurements-view :is-platform="isPlatform" :measurements="measurements"
                                                 :culture-practice-selected="culturePracticeSelected"
                                                 :connector-type-selected="connectorTypeSelected"/>
            </div>

        </div>
    </Dialog>
</template>

<script>
import Dialog from "primevue/dialog";
import AppImplementMeasurementsView from "@/components/views/implements/AppImplementMeasurementsView";
import {
    CONNECTOR_TYPES,
    CULTURE_PRACTICE_LIST,
    IMPLEMENT_POSITIONS,
    IMPLEMENTS_TYPES
} from "@/constants/ImplementConstants";
import dateHourFormat from "@/mixins/DateMixin";
export default {
    mixins: [dateHourFormat],
    data() {
        return {
            display: false,
            loadingMeasurements: true,
            implementTypes: IMPLEMENTS_TYPES,
            implementPositions: IMPLEMENT_POSITIONS,
            isPlatform: null,
            connectorTypes: CONNECTOR_TYPES,
            connectorTypeSelected: {},
            culturePracticeList: CULTURE_PRACTICE_LIST,
            culturePracticeSelected: {},
            measurements: {
                implement_position: {},
                crp: [null, 0, 0, null],
                function: [{
                    erp: [null, 0, 0],
                    description: null,
                    culture_practice: null,
                    number_of_sections: null,
                    width: null
                }]
            },
        }
    },
    methods: {
        closeDialog() {
            this.display = false;
            this.$emit('closeDialog');
        },
        parseMeasurements(modelMeasurements) {
            this.measurements.function = []
            if ('CRP' in modelMeasurements) {
                this.measurements.crp[0] = Math.trunc(Math.abs(modelMeasurements.CRP[0][0]) / 10)
                this.measurements.crp[3] = modelMeasurements.CRP[0][3]
                this.measurements.implement_position = this.parseImplementPosition(modelMeasurements.CRP[0][0])
            }
            modelMeasurements['Function'].forEach(implementFunction => {
                let parsedFunction = {
                    erp: [null, 0, 0],
                    description: null,
                    culture_practice: null,
                    number_of_sections: null,
                    width: null
                }
                if ('ERP' in implementFunction) {
                    parsedFunction.erp[0] = Math.trunc(Math.abs(implementFunction.ERP[0] / 10))
                }
                if ('Description' in implementFunction) {
                    parsedFunction.description = implementFunction.Description
                }
                if ('Culture_practice' in implementFunction) {
                    parsedFunction.culture_practice = implementFunction.Culture_practice
                }
                if ('Number_of_sections' in implementFunction) {
                    parsedFunction.number_of_sections = implementFunction.Number_of_sections
                }
                if ('Width' in implementFunction) {
                    parsedFunction.width = Math.trunc(implementFunction.Width / 10)
                }
                this.measurements.function.push(parsedFunction)
            })
        },
        parseImplementPosition(crpX) {
            if (crpX > 0) {
                return this.implementPositions[1]
            }
            return this.implementPositions[0]
        },
        setCulturePractice(culturePracticeCode) {
            let culturePracticeFound = this.culturePracticeList.find(culture => culture.value === culturePracticeCode)
            if (!culturePracticeFound) {
                this.culturePracticeSelected = this.culturePracticeList[0]
                return
            }
            this.culturePracticeSelected = culturePracticeFound
        },
        setConnectorType(connectorTypeCode) {
            let connectorTypeFound = this.connectorTypes.find(connector => connector.id === connectorTypeCode)
            if (!connectorTypeFound) {
                this.connectorTypeSelected = this.connectorTypes[0]
                return
            }
            this.connectorTypeSelected = connectorTypeFound
        },
        parseImplementType(vehicleTypeCode) {
            let foundImplement = this.implementTypes.find(type => type.value === vehicleTypeCode)
            if (foundImplement) {
                return foundImplement
            }
            return this.implementTypes[0]
        },
    },
    watch: {
        showDialog: function (val) {
            this.display = val;
            if (this.display) {
                this.loadingMeasurements = true
                this.isPlatform = this.implement.implement_type === 25
                this.parseMeasurements(JSON.parse(this.implement.descriptor))
                this.setCulturePractice(this.measurements.function[0].culture_practice)
                this.setConnectorType(this.measurements.crp[3])
                this.loadingMeasurements = false
            }
        }
    },
    props: {
        implement: {
            type: Object,
            required: true
        },
        showDialog: {
            type: Boolean,
            required: true
        },
    },
    components: {AppImplementMeasurementsView, Dialog}
}
</script>

<style scoped>
hr.dashed {
    border-top: 1px dashed #bbb;
}
.break-text {
    white-space: break-spaces;
    text-align: center;
}
.dialog-size {
    width: 40vw;
}
@media (max-width: 758px) {
    .dialog-size {
        width: 80vw;
    }
}
@media (max-width: 1024px) and (min-width: 758px) {
    .dialog-size {
        width: 60vw;
    }
}
</style>
